/**
 * Module launch related routes
 */

import RouterUtils from '@/utils/router';
import ModuleLaunch from '@/views/ModuleLaunch.vue';

export default [
  /** Module launch page */
  {
    path: '/launch/t/:topicId/m/:moduleId',
    name: 'moduleLaunch',
    component: ModuleLaunch,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
    ],
    props: true,
  },
];
